import { Box } from "@mui/material";
import React from "react";
import ScholarshipApplicationsTable from "./ScholarshipApplicationsTable";
import { SCHOLARSHIP_APPLICATIONS_TABLE_COLUMNS } from "../../data/scholarship-applications";
import { PaginationProps, ScholarshipApplicationDetailsProps } from "../../typings/scholarship-applications";

type ScholarshipApplicationsListProps = {
  applications: ScholarshipApplicationDetailsProps[];
  pagination: PaginationProps;
  loading: boolean;
  searchTerm?: string;
  onPageChange: (e: unknown, page: number) => void;
  onRowsPerPageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRefresh: () => void;
};

const ScholarshipApplicationsList: React.FC<ScholarshipApplicationsListProps> = ({
  applications,
  pagination,
  loading,
  searchTerm = "",
  onPageChange,
  onRowsPerPageChange,
  onRefresh,
}) => {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <ScholarshipApplicationsTable
        columns={SCHOLARSHIP_APPLICATIONS_TABLE_COLUMNS}
        data={applications}
        pagination={pagination}
        loading={loading}
        searchTerm={searchTerm}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        onRefresh={onRefresh}
      />
    </Box>
  );
};

export default ScholarshipApplicationsList;
